var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('jumbo-container'),_c('a',{attrs:{"id":"services"}}),_c('services-container'),_c('benefit-container'),_c('testimonios-container'),_c('newsletter-container'),_c('seccion-de-articulos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }